function orderStoreFilters(filters, order) {
  const orderMap = new Map(order.map((name, index) => [name, index]));
  return filters.slice().sort((a, b) => {
    const indexA = orderMap.get(a.name) ?? Infinity;
    const indexB = orderMap.get(b.name) ?? Infinity;
    return indexA - indexB;
  });
}
export {
  orderStoreFilters
};
//# sourceMappingURL=order-store-filters.js.map
